import { type___locale___translations___collection } from "../../../types/types.locale";

//	E X P O R T   L O C A L E

export const locale___SbSettingsMainPage: type___locale___translations___collection = {
	'ionAlert___askForLogout___title': {
		de_de: 'Du bist dabei, dich abzumelden',
		en_us: 'You are about to log out',
		es_es: 'Estás a punto de cerrar sesión',
		fr_fr: 'Vous êtes sur le point de vous déconnecter',
		it_it: 'Stai per effettuare il logout',
	},
	'ionAlert___askForLogout___message': {
		de_de: 'Möchtest du fortfahren?',
		en_us: 'Do you want to continue?',
		es_es: '¿Quieres continuar?',
		fr_fr: 'Voulez-vous continuer ?',
		it_it: 'Vuoi continuare?',
	},
	'account': {
		de_de: 'Konten',
		en_us: 'Account',
		es_es: 'Cuentas',
		fr_fr: 'Comptes',
		it_it: 'Account',
	},
	'account___auth': {
		de_de: 'Authentifizierung',
		en_us: 'Authentication',
		es_es: 'Autenticación',
		fr_fr: 'Authentification',
		it_it: 'Autenticazione',
	},
	'account___logout': {
		de_de: 'Abmelden',
		en_us: 'Logout',
		es_es: 'Cerrar sesión',
		fr_fr: 'Déconnexion',
		it_it: 'Logout',
	},
	'preferences': {
		de_de: 'Präferenzen',
		en_us: 'Preferences',
		es_es: 'Preferencias',
		fr_fr: 'Préférences',
		it_it: 'Preferenze',
	},
	'preferences___language': {
		de_de: 'Sprache',
		en_us: 'Language',
		es_es: 'Lengua',
		fr_fr: 'Langue',
		it_it: 'Lingua',
	},
	'support': {
		de_de: 'Hilfe und Support',
		en_us: 'Assistance and Support',
		es_es: 'Asistencia y Soporte',
		fr_fr: 'Assistance et soutien',
		it_it: 'Assistenza e Supporto',
	},
	'support___suggest_a_feature': {
		de_de: 'Schlagen Sie eine Funktion vor',
		en_us: 'Suggest a feature',
		es_es: 'Sugerir una característica',
		fr_fr: 'Suggérer une fonctionnalité',
		it_it: 'Suggerisci una funzione',
	},
	'support___contact_us': {
		de_de: 'Kontakte und Hilfe',
		en_us: 'Contact Us and Support',
		es_es: 'Contactos y Asistencia',
		fr_fr: 'Contacts et Assistance',
		it_it: 'Contatti e Assistenza',
	},
	'about': {
		de_de: 'Info',
		en_us: 'About',
		es_es: 'Información',
		fr_fr: 'Info',
		it_it: 'Info',
	},
	'about___eula': {
		de_de: 'EULA und Cookie-Richtlinie',
		en_us: 'EULA and Cookie Policy',
		es_es: 'CLUF y política de cookies',
		fr_fr: 'CLUF et politique en matière de cookies',
		it_it: 'EULA e Cookie Policy',
	},
	'about___licences': {
		de_de: 'Lizenzen Dritter',
		en_us: 'Third parties Licences',
		es_es: 'Licencias de terceros',
		fr_fr: 'Licences tierces',
		it_it: 'Licenze di terze parti',
	},
	'about___copyright': {
		de_de: 'Copyright',
		en_us: 'Copyright',
		es_es: 'Copyright',
		fr_fr: 'Copyright',
		it_it: 'Copyright',
	},
};